import React, { useEffect } from "react";
import { Carousel, LoadingSkeleton } from "components";
import { BsFillPersonFill } from "react-icons/bs";
import { AiOutlineRight } from "react-icons/ai";
import { Typography } from "components";
import { ROUTES } from "routes/routePaths";
import { useNavigate } from "react-router-dom";
import { getOnboardingSummary } from "redux/actions/dashboard/onboardingDashboardActions";
import { useSelector } from "react-redux";

const SummaryCards = () => {
  const navigate = useNavigate();

  const { userType, dates, summaryCards } = useSelector(
    (state) => state.onboardingReducer
  );

  useEffect(() => {
    getOnboardingSummary(userType, dates);
    //eslint-disable-next-line
  }, [userType]);

  const {
    isError,
    registered,
    enabled,
    ongoingRegistration,
    awaitingAuthorization,
    deactivated,
    rejectedRegistration,
  } = summaryCards?.data || {};

  const cardDetails = [
    {
      title: "Total Registered",
      value: registered,
      iconColor: "#1966FC",
      link: ROUTES.agentManagement,
    },
    {
      title: "Pending Registration",
      value: ongoingRegistration,
      iconColor: "#1966FC",
    },
    {
      title: "Total Enabled",
      value: enabled,
      iconColor: "#102E88",
    },
    {
      title: "Awaiting Authorization",
      value: awaitingAuthorization,
      iconColor: "#1966FC",
    },
    {
      title: "Disabled",
      value: deactivated,
      iconColor: "#778CA2",
    },
    {
      title: "Rejected Registration",
      value: rejectedRegistration,
      iconColor: "#CBD6F8",
    },
  ];

  return (
    <div className="mt-4">
      <Carousel showArrows={!summaryCards.loading}>
        {cardDetails.map(({ title, value, iconColor, link }, key) =>
          summaryCards.loading ? (
            <div className="mx-2" key={key}>
              <LoadingSkeleton height={"9rem"} />
            </div>
          ) : (
            <div
              className={`dashboard-card aggregator-summary-card px-3 pt-4 pb-2 ${
                link ? "cursor-pointer" : ""
              }`}
              onClick={() => (link ? navigate(link) : {})}
              key={key}
            >
              <Typography variant="body4" state="primary">
                {title} {userType.toLowerCase()}s
              </Typography>
              <div className="d-flex justify-content-between align-items-center mt-1">
                <Typography
                  state="secondary"
                  variant="heading3"
                  style={{ fontSize: "22px" }}
                >
                  {isError ? 0 : value}
                </Typography>
                <div className="agent-icon-container d-flex align-items-center justify-content-center">
                  <BsFillPersonFill color={iconColor} fontSize={"24px"} />
                </div>
              </div>
              {link && (
                <div className="d-flex justify-content-end pr-4 mt-3">
                  <AiOutlineRight color="#3D3333" />
                </div>
              )}
            </div>
          )
        )}
      </Carousel>
    </div>
  );
};

export default SummaryCards;
